import { api } from '../api'

const state = {
  advertisements: [],
  advertisementsLoaded: false,
  plans: [],
  plansLoaded: false,
  // OVERLAYS - media preview
  overlays: {
    advertisement: {
      filetype: "",
      display: false,
      content: "",
      displayError: false,
      error: "",
    },
  },
}

const mutations = {
  'ADD_ADVERTISEMENT'(state, payload) {
    if (payload) {
      // then, push an entry to global state
      state.advertisements.push({
        idAdvertisement: payload.idAdvertisement,
        Title: payload.advertisementtitle,
        displaymedia: payload.advertisementdisplaymediafile,
        status: 'pending',
        broadcastmedia: payload.advertisementmediafile,
        FileType: payload.FileType,
        CreatedAt: payload.CreatedAt
      })
    }
  },
  'INIT_ADVERTISEMENTS'(state, payload) {
    state.advertisements = payload;
  },
  'DELETE_ADVERTISEMENT'(state, payload){
    if(payload){
      // deliberately avoided es6 functions as they yielded incorrect results (whysoever)
      for (let i = 0; i < state.advertisements.length; i++) {
        if (state.advertisements[i].idAdvertisement === payload) {
          state.advertisements.splice(i, 1)
          return
        }
      }
    }
  },
  'TOGGLE_ADVERTISEMENT_STATUS'(state) {
    state.advertisementsLoaded = !state.advertisementsLoaded
  },
  'ADD_PLAN'(state, payload) {
    if (payload) {
      // then, push an entry to global state
      state.plans.push(payload)
    }
  },
  'REMOVE_PLAN'(state, payload) {
    if (payload) {
      // deliberately avoided es6 functions as they yielded incorrect results (whysoever)
      for (let i = 0; i < state.plans.length; i++) {
        if (state.plans[i].idPlan === payload.plannerid) {
          state.plans.splice(i, 1)
          return
        }
      }
    }
  },
  'UPDATE_PLAN'(state, payload) {
    if (payload) {
      // update publicitygroup global state
      let plan = state.plans.find(plan => plan.idPlan === payload.plannerid)
      plan.plannertitle = payload.plannertitle
      plan.Advertisement_id = payload.plannerad.advertisementid
      plan.advertisementtitle = payload.plannerad.advertisementtitle
      plan.FileType = payload.plannerad.advertisementfiletype
      plan.Publicitygroup_id = payload.plannergroup.publicitygroupid
      plan.Groupname = payload.plannergroup.publicitygroupname
      plan.startdate = payload.plannerperiod.start.split('T')[0]
      plan.enddate = payload.plannerperiod.end.split('T')[0]
      plan.locations = payload.locations
      plan.duration = payload.duration
      plan.outreach = payload.outreach
    }
  },
  'INIT_PLANS'(state, payload) {
    state.plans = payload;
  },
  'TOGGLE_PLAN_STATUS'(state) {
    state.plansLoaded = !state.plansLoaded
  },
  'SET_ADVERTISEMENT_OVERLAY'(state, payload) {
    state.overlays.advertisement.filetype = payload.data.data.filetype;
    state.overlays.advertisement.content = payload.data.data.url;
    state.overlays.advertisement.display = true;
  },
  'ADVERTISEMENT_OVERLAY_ERROR': (state) => {
    state.overlays.advertisement.displayError = true;
    state.overlays.advertisement.error = `Die Dateivorschau ist für dieses Element nicht verfügbar.\nBitte wenden Sie sich an Ihren Administrator.`;
    state.overlays.advertisement.display = true;
  },
  'CLEAR_OVERLAYS': (state) => {
    Object.keys(state.overlays).forEach(key => {
      Object.keys(state.overlays[key]).forEach(val => {
        if (val === 'content') {
          state.overlays[key][val] = "";
        } else if (val === 'display') {
          state.overlays[key][val] = false;
        } else if (val === 'displayError') {
          state.overlays[key][val] = false;
        } else if (val === 'error') {
          state.overlays[key][val] = "";
        } else if (val === 'filetype') {
          state.overlays[key][val] = "";
        } else {
          return
        }
      })
    });
  },
}

const getters = {
  getAdvertisementApprovallist: state => {
    // first sort by creationdate; then, map advertisement data to table format
    return state.advertisements.sort((a, b) => {
      return new Date(b.CreatedAt) - new Date(a.CreatedAt)
    }).map(advertisement => {
      return {
        advertisementtitle: advertisement.Title,
        advertisementtype: advertisement.FileType,
        advertisementstatus: advertisement.status,
        advertisementid: advertisement.idAdvertisement,
        advertisementmediafile: advertisement.broadcastmedia,
        advertisementdisplaymediafile: advertisement.displaymedia,
        advertisementcreationdate: advertisement.CreatedAt
      }
    })
  },
  getAdvertisementStatus: state => {
    return state.advertisementsLoaded
  },
  getAdvertisementId: (state) => (payload) => {
    return state.advertisements.find((advertisement) => {
      return advertisement.advertisementfacility === payload.advertisementfacility && advertisement.advertisementfirstname === payload.advertisementfirstname && advertisement.advertisementlastname === payload.advertisementlastname
    }).idAdvertisement
  },
  getAdvertisementById: (state) => (payload) => {
    return state.advertisements.find(advertisement => advertisement.idAdvertisement === payload)
  },
  getAdvertisementIds: (state) => {
    return state.advertisements.map(advertisement => advertisement.idAdvertisement)
  },
  getAdvertisementIdByTitle: (state) => (payload) => {
    return state.advertisements.find(ad => ad.Title === payload).idAdvertisement
  },
  getConfirmedAdvertisementsNames: (state) => {
    return state.advertisements.filter(advertisement => advertisement.status === 'confirmed').map(ad => ad.Title)
  },
  getPlanOverview: state => {
    return state.plans.sort((a, b) => {
      return new Date(b.CreatedAt) - new Date(a.CreatedAt)
    }).map(plan => {
      return {
        plannerid: plan.idPlan,
        plannertitle: plan.plannertitle,
        planneradvertisement: plan.advertisementtitle,
        plannergroup: plan.Groupname,
        plannertype: plan.FileType,
        plannerstartdate: plan.startdate,
        plannerenddate: plan.enddate,
        plannerimpressionsday: plan.impressionsday,
        plannerimpressionsoverall: plan.impressionsoverall,
        plannerclicks: plan.activeclicks,
        planneroutreach: plan.outreach,
        plannermonitorinteractions: plan.overallinteractions,
        plannerduration: plan.duration,
        plannerstatus: (new Date(plan.startdate) <= new Date() && new Date() <= new Date(plan.enddate)) ? 'Ausgestrahlt' : 'Inaktiv',
        Publicity_id: plan.Publicity_id
      }
    })
  },
  getPlanStatus: state => {
    return state.plansLoaded
  },
  // SUBMIT PLAN(S)
  getPlannerAdvertisementObjects: (state) => (payload) => {
    return state.advertisements.filter(advertisement => payload.includes(advertisement.Title)).map(ad => {
      return {
        advertisementid: ad.idAdvertisement,
        advertisementfiletype: ad.FileType,
      }
    })
  },
  // UPDATE PLAN
  getPlannerAdvertisementObject: (state) => (payload) => {
    let ad = state.advertisements.find(advertisement => payload === advertisement.Title)
    return {
      advertisementid: ad.idAdvertisement,
      advertisementfiletype: ad.FileType,
      advertisementtitle: ad.Title
    }
  },
  getDisplayAdvertisementOverlay: state => {
    return state.overlays.advertisement.display;
  },
  getAdvertisementOverlayContent: state => {
    return state.overlays.advertisement.content
  },
  advertisementOverlayError: state => {
    return state.overlays.advertisement.displayError
  },
  getAdvertisementOverlayErrorContent: state => {
    return state.overlays.advertisement.error
  },
  getAdvertisementOverlayFiletype: state => {
    return state.overlays.advertisement.filetype
  },
}

const actions = {
  loadAdvertisements: ({ commit, state, rootState }) => {
    return new Promise(resolve => {
      api.queryAPIServerGet(process.env.VUE_APP_ROOT_API + "/publicitycustomer/advertisements/get", { pid: rootState.auth.pid, username: rootState.auth.Username }, (response) => {
        let res = response.data;

        if (res.error) {
          console.error('An error occured. Please try again later.')
          resolve(1)
          return
        }
        commit("INIT_ADVERTISEMENTS", res.data)
        if (!state.advertisementsLoaded) {
          commit('TOGGLE_ADVERTISEMENT_STATUS')
        }
        resolve(0)
      })
    })
  },
  submitAdvertisement: ({ commit, rootState }, payload) => {
    // create new payload for server, "replacing" files for filenames (AS does not require complete files)
    // to minimize network traffic
    // as a side effect: new ad custom validations work correctly since "old" payload stays untouched
    let payloadData = {
      pid: rootState.auth.pid,
      username: rootState.auth.Username,
      advertisementmediafile: payload.advertisementmediafile.name,
      advertisementdisplaymediafile: payload.advertisementdisplaymediafile.name,
      advertisementtitle: payload.advertisementtitle
    }

    return new Promise((resolve) => {
      // write to database
      api.queryAPIServerPost(process.env.VUE_APP_ROOT_API + "/publicitycustomer/advertisements/submit", payloadData, async (response) => {
        let res = response.data;

        if (res.error) {
          console.error('An error occured. Please try again later.');
          resolve(1)
          return
        }

        // replace "old" filenames with new ones (see AS for renaming scheme)
        payloadData.idAdvertisement = res.data.aid
        payloadData.advertisementtype = res.data.advertisementtype
        payloadData.advertisementtitle = res.data.advertisementtitle
        payloadData.advertisementmediafile = res.data.advertisementmediafilename
        payloadData.advertisementdisplaymediafile = res.data.advertisementdisplaymediafilename

        // push files to S3
        if (res.data.mediafileurl) {
          api.queryAPIServerPut(res.data.mediafileurl, payload.advertisementmediafile);
        }
        if (res.data.displaymediafileurl) {
          api.queryAPIServerPut(res.data.displaymediafileurl, payload.advertisementdisplaymediafile)
        }

        // add to global state
        commit('ADD_ADVERTISEMENT', payloadData)
        resolve(0)
      })
    })
  },
  updateAdvertisement: ({ commit, rootState }, payload) => {
    payload.bid = rootState.auth.bid
    payload.username = rootState.auth.Username
    api.queryAPIServerPost(process.env.VUE_APP_ROOT_API + "/publicitycustomer/advertisement/update", payload, (response) => {
      let data = response.data.data
      payload.advertisementid = data.advertisementid
      payload.flatmates = data.flatmates
      payload.advertisementfacility = data.advertisementfacility
      payload.advertisementapartment = data.advertisementapartmentnew
      commit('UPDATE_ADVERTISEMENT', payload)
    });
  },
  deleteAd: ({ commit, rootState }, payload) => {
    let deleteAdPayload = {
      pid: rootState.auth.pid,
      username: rootState.auth.Username
    };
    
    deleteAdPayload.aid = payload.advertisementid;
    
    api.queryAPIServerPost(process.env.VUE_APP_ROOT_API + "/publicitycustomer/advertisement/update", deleteAdPayload, (response) => {
      let data = response.data.data
      
      commit('DELETE_ADVERTISEMENT', deleteAdPayload.aid)
    });
  },
  loadPlans: ({ commit, state, rootState }) => {
    return new Promise(resolve => {
      api.queryAPIServerGet(process.env.VUE_APP_ROOT_API + "/publicitycustomer/plan/get", { pid: rootState.auth.pid, username: rootState.auth.Username }, (response) => {
        let res = response.data;

        if (res.error) {
          console.error('An error occured. Please try again later.')
          resolve(1)
          return
        }

        commit("INIT_PLANS", res.data)
        if (!state.plansLoaded) {
          commit('TOGGLE_PLAN_STATUS')
        }
        resolve(0)
      })
    })
  },
  submitPlans: ({ commit, rootState, getters }, payload) => {

    let serverPayload = JSON.parse(JSON.stringify(payload));

    serverPayload.pid = rootState.auth.pid;
    serverPayload.username = rootState.auth.Username;

    // transform dates:
    serverPayload.plannerperiod.start = serverPayload.plannerperiod.start.split('T')[0]
    serverPayload.plannerperiod.end = serverPayload.plannerperiod.end.split('T')[0]

    serverPayload.plannerads = getters.getPlannerAdvertisementObjects(payload.plannerads)
    serverPayload.plannergroups = getters.getPlannerPublicitygroupObjects(payload.plannergroups)

    return new Promise(resolve => {
      api.queryAPIServerPost(process.env.VUE_APP_ROOT_API + "/publicitycustomer/plan/submit", serverPayload, (response) => {
        let res = response.data;

        if (res.error) {
          console.log('An error occured. Please try again later.')
          resolve(1)
          return
        }

        for (let plan of res.data) {
          commit('ADD_PLAN', plan)
        }

        resolve(0)
      });
    })
  },
  updatePlan: ({ commit, rootState, getters }, payload) => {
    let serverPayload = JSON.parse(JSON.stringify(payload));

    serverPayload.pid = rootState.auth.pid;
    serverPayload.username = rootState.auth.Username;

    // transform dates:
    serverPayload.plannerperiod.start = serverPayload.plannerperiod.start.split('T')[0]
    serverPayload.plannerperiod.end = serverPayload.plannerperiod.end.split('T')[0]

    serverPayload.plannerad = getters.getPlannerAdvertisementObject(payload.plannerad)
    serverPayload.plannergroup = getters.getPlannerPublicitygroupObject(payload.plannergroup)

    return new Promise(resolve => {
      api.queryAPIServerPost(process.env.VUE_APP_ROOT_API + "/publicitycustomer/plan/update", serverPayload, (response) => {
        let res = response.data;

        if (res.error) {
          console.log('An error occured. Please try again later.')
          resolve(1)
          return
        }
        console.log(res.data)

        // attach changes to mutation payload
        for (let key of Object.keys(res.data)) {
          serverPayload[key] = res.data[key];
        }
        console.log(serverPayload)
        // server does not return actual payload; all changes are passed to this action from
        // editplanner-form, hence pass this exact payload to mutation
        commit('UPDATE_PLAN', serverPayload)
        resolve(0)
      });
    })
  },
  loadAdvertisementDisplaymediaURL: ({ commit, rootState }, payload) => {
    payload.pid = rootState.auth.pid;
    payload.username = rootState.auth.Username
    api.queryAPIServerGet(process.env.VUE_APP_ROOT_API + "/publicitycustomer/advertisement/displaymediaurl/get", payload, (response) => {

      if (response.data.error || !response.data.data.url || !response.data.data.filetype) {
        commit('ADVERTISEMENT_OVERLAY_ERROR');
        return;
      }

      commit('SET_ADVERTISEMENT_OVERLAY', response);
    })
  },
  loadAdvertisementMediaURL: ({ commit, rootState }, payload) => {
    payload.pid = rootState.auth.pid;
    payload.username = rootState.auth.Username
    api.queryAPIServerGet(process.env.VUE_APP_ROOT_API + "/publicitycustomer/advertisement/mediaurl/get", payload, (response) => {

      if (response.data.error || !response.data.data.url || !response.data.data.filetype) {
        commit('ADVERTISEMENT_OVERLAY_ERROR');
        return;
      }

      commit('SET_ADVERTISEMENT_OVERLAY', response);
    })
  },
  clearOverlays: ({ commit }) => {
    commit('CLEAR_OVERLAYS');
  },
  deletePlan: ({ commit, rootState }, payload) => {
    payload.pid = rootState.auth.pid;
    payload.username = rootState.auth.Username

    console.log("plan to delete: " + payload.plannerid)

    return new Promise(resolve => {
      api.queryAPIServerPost(process.env.VUE_APP_ROOT_API + "/publicitycustomer/plan/delete", payload, (response) => {
        let res = response.data;

        if (res.error) {
          console.log('An error occured. Please try again later.')
          resolve(1)
          return
        }

        commit('REMOVE_PLAN', res.data)
        resolve(0)
      });
    })
  },
}

export default {
  state,
  mutations,
  getters,
  actions
}
